import React from "react";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import { Close as CloseIcon } from "@material-ui/icons";
import { Button, Labelbox, Modal } from "./index";

const FILING_STATUS_OPTIONS = [
  { id: "", value: "Select", keepAtTop: true },
  { id: "Efiled", value: "Efiled" },
  { id: "Pending", value: "Pending" },
  { id: "Rejected", value: "Rejected" },
];

export default function EfilingStatusEditModal({
  open,
  onClose,
  saving,
  form,
  setForm,
  formErrors = {},
  onClearError,
  onSave,
  isRejectedStatus,
  isAdmin,
}) {
  const setField = (key, value) => {
    if (onClearError) onClearError(key);
    setForm((s) => ({ ...s, [key]: value }));
  };

  const statusOptions = (isRejectedStatus && !isAdmin)
    ? [{ id: "Pending", value: "Pending" }]
    : FILING_STATUS_OPTIONS;

  return (
    <Modal
      title={null}
      open={open}
      handleClose={() => !saving && onClose()}
      className="efiling-create-modal"
    >
      <div className="efiling-modal-shell">
        <div className="efiling-modal-header-row">
          <h3 className="efiling-modal-title">Edit Status</h3>
          <IconButton
            aria-label="close"
            className="efiling-modal-close-btn"
            onClick={() => !saving && onClose()}
            disabled={saving}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <Grid container spacing={2} className="efiling-form-grid">
          <Grid item xs={12} md={6}>
            <Labelbox
              type="select"
              labelname="Status"
              dropdown={statusOptions}
              value={form.filing_status || "Pending"}
              changeData={(v) => setField("filing_status", v)}
              disabled={saving}
              error={Boolean(formErrors.filing_status)}
              errmsg={formErrors.filing_status}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Labelbox
              type="text"
              labelname="Filer comment"
              value={form.other_comments}
              changeData={(v) => setField("other_comments", v)}
              error={Boolean(formErrors.other_comments)}
              errmsg={formErrors.other_comments}
              disabled={saving}
            />
          </Grid>
        </Grid>

        <div className="efiling-modal-actions">
          <Button
            text="Cancel"
            ui="transparent"
            variant="outline"
            disable={saving}
            handleClick={onClose}
          />
          <Button
            text={saving ? "Saving…" : "Save"}
            disable={saving}
            handleClick={onSave}
          />
        </div>
      </div>
    </Modal>
  );
}
